import Promise from 'bluebird'
import _isArray from 'lodash/isArray'

import surfsideClient from 'lib/analyticsIntegrationClients/surfside/index'
import INTEGRATION_TYPES from 'constants/integrationTypes'

let venueIntegrations = []

function getIntegrationClientByType(type) {
  if (!type) throw new Error('type')

  switch (type) {
    case INTEGRATION_TYPES.SURFSIDE:
      return surfsideClient
    default:
      return null
  }
}

function getSurfSideIntegrationParams(integration) {
  return {
    aid: integration.surfside.accountId || undefined,
    cid: integration.surfside.campaignId || undefined,
    lid: integration.surfside.lineItemId || undefined,
  }
}

export default {
  init(integrations) {
    if (!integrations || !_isArray(integrations)) return

    venueIntegrations = integrations

    venueIntegrations.forEach((integration) => {
      if (integration.surfside) {
        integration.type = INTEGRATION_TYPES.SURFSIDE
      }
    })
  },
  pageView() {
    return Promise.map(venueIntegrations, (integration) => {
      const client = getIntegrationClientByType(integration.type)

      if (!client) {
        console.log(`no integration client found for type ${integration.type}`) //eslint-disable-line

        return null
      }

      if (integration.type === INTEGRATION_TYPES.SURFSIDE) {
        return client.pageView(Object.assign(getSurfSideIntegrationParams(integration), {}))
      }

      return null
    })
  },
  track(event, data) {
    if (!event) throw new Error('event')
    if (!data) throw new Error('data')

    return Promise.map(venueIntegrations, (integration) => {
      const client = getIntegrationClientByType(integration.type)

      if (!client) {
        console.log(`no integration client found for type ${integration.type}`) //eslint-disable-line

        return null
      }

      if (integration.type === INTEGRATION_TYPES.SURFSIDE) {
        return client.track(event, Object.assign(getSurfSideIntegrationParams(integration), data))
      }

      return null
    })
  },
}



// WEBPACK FOOTER //
// ./src/lib/integrations.js